import { Link } from 'react-router-dom';
import './About.css';

export default function About() {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="about-hero-image" aria-hidden="true" />
        <div className="about-hero-bg" aria-hidden="true" />
        <div className="about-hero-content">
          <p className="about-eyebrow">About the platform</p>
          <h1 className="about-title">A shared regional events calendar for practical planning.</h1>
          <p className="about-lead">
            Built for New England North West so employers, councils, tourism teams and community
            organisations can plan earlier and coordinate around event-driven demand.
          </p>
          <div className="about-hero-actions">
            <Link to="/events" className="about-cta about-cta-solid">
              Open events calendar
            </Link>
            <Link to="/submit" className="about-cta about-cta-ghost">
              Submit an event
            </Link>
          </div>
        </div>
      </section>

      <section className="about-section about-intro">
        <div className="about-copy-card">
          <p className="about-tag">How it works</p>
          <h2>One source of truth for regional event visibility.</h2>
          <p>
            Event information is often fragmented across social channels, flyers and disconnected
            websites. This platform consolidates those signals into one shared timeline.
          </p>
          <p>
            That timeline helps organisations move from reactive decisions to coordinated planning
            for staffing, service readiness, logistics and communications.
          </p>
        </div>
        <div className="about-visual" aria-hidden="true" />
      </section>

      <section className="about-section about-pillar-grid">
        <article className="about-pillar-card">
          <span>01</span>
          <h3>Why we built it</h3>
          <p>
            Regional events create predictable demand spikes across hospitality, tourism and local
            services. A shared view helps stakeholders prepare earlier.
          </p>
        </article>
        <article className="about-pillar-card">
          <span>02</span>
          <h3>Who uses it</h3>
          <p>
            Employers, councils, visitor economy teams, arts and sporting organisations, and
            workforce providers use the calendar for place-based planning.
          </p>
        </article>
        <article className="about-pillar-card">
          <span>03</span>
          <h3>What to do next</h3>
          <p>
            Explore upcoming events, save those relevant to operations, and submit verified event
            details to keep the regional picture current.
          </p>
        </article>
      </section>

      <section className="about-section about-program">
        <div className="about-program-inner">
          <p className="about-tag">Local Jobs Program alignment</p>
          <h2>Planning outcomes this platform supports</h2>
          <div className="about-program-grid">
            <article className="about-program-card">
              <h3>Workforce readiness</h3>
              <p>Align recruitment and rostering with event periods to reduce last-minute pressure.</p>
            </article>
            <article className="about-program-card">
              <h3>Service coordination</h3>
              <p>Support councils and community services with clearer forward visibility.</p>
            </article>
            <article className="about-program-card">
              <h3>Regional collaboration</h3>
              <p>Build a stronger shared planning capability through ongoing local contributions.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="about-section about-footer-note">
        <p>
          Regional Events Calendar — <strong>events.localjobsnenw.com.au</strong> · Connected with{' '}
          <a href="https://www.localjobsnenw.com.au" target="_blank" rel="noreferrer">
            localjobsnenw.com.au
          </a>
        </p>
      </section>
    </div>
  );
}
